import styled from "styled-components";

const FooterLogoContainer = styled.div`
  width: 200px;

  @media (max-width: 575px) {
    width: 100%;
    padding: 0 90px;
    margin-bottom: 20px;
  }
`;
export default FooterLogoContainer;